import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';
import { dayInMilliseconds } from 'utils/utils';
import Loading from 'components/Loading/Loading';
import BookPrice from 'components/BookPrice/BookPrice';

export const baseClass = 'panda-calendar__table__page__day';

const highlightMapModifiers = {
  unavailable: 'is-unavailable',
  selected: 'is-during-duration',
  depart: 'is-departure',
  checkin: 'is-check-in',
  return: 'is-return-date',
};

function getHighlight(date) {
  let highlights = '';

  if (date.highlight) {
    highlights += ` ${baseClass}--${highlightMapModifiers[date.highlight]}`;
  }

  if (date.cheapest) {
    highlights += ` ${baseClass}--is-cheapest`;
  }

  return `${baseClass}${highlights}`;
}

export default class CalDate extends Component {
  static propTypes = {
    date: PropTypes.object,
    appState: PropTypes.object.isRequired,
    onClickDate: PropTypes.func.isRequired,
    showPlaneIcon: PropTypes.bool,
    showPricePerNight: PropTypes.bool,
    numberOfNights: PropTypes.number,
  };

  shouldComponentUpdate = shouldPureComponentUpdate;

  isCurrentMonth(month) {
    return month === this.props.date.month;
  }

  handleDateClick = (e) => {
    e.preventDefault();
    const theDate = this.props.date;
    const calDate = Date.UTC(theDate.year, theDate.month, theDate.day) / dayInMilliseconds;
    this.props.onClickDate(calDate);
  };

  render() {
    const {
      date,
      showPlaneIcon,
      showPricePerNight,
      numberOfNights,
    } = this.props;

    const isSpinning = date && date.highlight === 'depart' && this.props.appState.get('loadingState');

    const divisor = showPricePerNight ? numberOfNights : 1;

    let listItem;

    if (date) {
      const dateContents = (
        <div>
          <time
            dateTime={`${date.year}-${date.month + 1}-${date.day}`}
            className={`${showPlaneIcon ? `${baseClass}__number ${baseClass}__number--plane` : `${baseClass}__number`}`}
          >
            {date.day}
          </time>
          <div className={`${baseClass}__price`}>
            { !isSpinning && !!date.price && <BookPrice price={date.price} isRounded isStrong={false} divisor={divisor} /> }
          </div>
        </div>
      );

      listItem = (
        <td className={`${getHighlight(date)} ${this.isCurrentMonth(date.month) ? '' : `${baseClass}--is-not-this-month`}`}>
          { date.price && date.highlight !== 'depart' ? (
            <a
              href="#"
              className={`${baseClass}__link`}
              onClick={this.handleDateClick}
            >
              { dateContents }
            </a>
          ) : (
            <div>{ dateContents }</div>
          )}

          { date.highlight === 'depart' &&
            <Loading loadingState={this.props.appState.get('loadingState')} isSmall />
          }
        </td>
      );
    } else {
      listItem = (
        <td className={`${baseClass}--is-not-this-month ${baseClass}`}>
          <time className={`${showPlaneIcon ? `${baseClass}__number ${baseClass}__number--plane` : `${baseClass}__number`}`} />
          <div className={`${baseClass}__price`} />
        </td>
      );
    }

    return listItem;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/PandaCalendar/Date.jsx
 **/